import __request__ from 'routing/request';
interface SummaryRequestParameters__AIParameters {
    readonly top_p: number;
    readonly max_gen_length: number;
    readonly temperature: number;
}
interface InvestigationSummary {
    readonly summary: string;
    readonly template: string;
    readonly model: string;
}
interface InvestigationReportResponse {
    readonly text: string;
}
interface SummaryRequestParameters {
    readonly template: string;
    readonly ai_parameters: SummaryRequestParameters__AIParameters;
    readonly model: string;
    readonly prompt: string;
    readonly logs: string[];
    readonly events: string[];
    readonly invalidate_cached_summary: boolean;
}
/**
 * Retrieves default prompt template used for AI investigation summary generation
 */
export function defaultPrompt(): Promise<string> {
    return __request__('GET', '/plugins/org.graylog.plugins.securityapp/investigations/summary/prompt', null, {}, {
        'Accept': ['text/plain']
    });
}
/**
 * Retrieves prompt template used for AI investigation summary generation
 */
export function prompt(templateName: string): Promise<string> {
    return __request__('GET', `/plugins/org.graylog.plugins.securityapp/investigations/summary/prompt/${templateName}`, null, {}, {
        'Accept': ['text/plain']
    });
}
/**
 * creates a summary for the given investigation
 */
export function investigationReport(investigationId: string): Promise<InvestigationReportResponse> {
    return __request__('GET', `/plugins/org.graylog.plugins.securityapp/investigations/summary/${investigationId}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * creates a summary for the given investigation
 */
export function summary(investigationId: string, JSONBody?: SummaryRequestParameters): Promise<InvestigationSummary> {
    return __request__('POST', `/plugins/org.graylog.plugins.securityapp/investigations/summary/${investigationId}`, JSONBody, {}, {
        'Accept': ['application/json']
    });
}
